export const freeCancellationPeriodOptions = [
  { value: 'HOURS_24', text: 'cms:cms.properties.edit.detail.free_cancellation_period.24_hours' },
  { value: 'HOURS_48', text: 'cms:cms.properties.edit.detail.free_cancellation_period.48_hours' },
  { value: 'HOURS_72', text: 'cms:cms.properties.edit.detail.free_cancellation_period.72_hours' },
  {
    value: 'BUSINESS_DAYS_5',
    text: 'cms:cms.properties.edit.detail.free_cancellation_period.5_business_days',
  },
  {
    value: 'CALENDAR_DAYS_5',
    text: 'cms:cms.properties.edit.detail.free_cancellation_period.5_calendar_days',
  },
  {
    value: 'CALENDAR_DAYS_7',
    text: 'cms:cms.properties.edit.detail.free_cancellation_period.7_calendar_days',
  },
  {
    value: 'CALENDAR_DAYS_14',
    text: 'cms:cms.properties.edit.detail.free_cancellation_period.14_calendar_days',
  },
  {
    value: 'CALENDAR_DAYS_28',
    text: 'cms:cms.properties.edit.detail.free_cancellation_period.28_calendar_days',
  },
  {
    value: 'UNTIL_THE_STUDENT_PAYS_FOR_THE_RENT',
    text: 'cms:cms.properties.edit.detail.free_cancellation_period.until_the_student_pays_for_the_rent',
  },
  {
    value: 'NO_COOLING_OFF_PERIOD',
    text: 'cms:cms.properties.edit.detail.free_cancellation_period.no_cooling_off_period',
  },
  { value: 'OTHER', text: 'cms:cms.properties.edit.detail.free_cancellation_period.other' },
];

export const longtailFreeCancellationPeriodOptions = [
  {
    value: 'BEFORE_MOVE_IN_CALENDAR_DAYS_0',
    text: 'cms:cms.properties.edit.detail.cancellation_period.0_calendar_days',
  },
  {
    value: 'BEFORE_MOVE_IN_CALENDAR_DAYS_7',
    text: 'cms:cms.properties.edit.detail.cancellation_period.7_calendar_days',
  },
  {
    value: 'BEFORE_MOVE_IN_CALENDAR_DAYS_14',
    text: 'cms:cms.properties.edit.detail.cancellation_period.14_calendar_days',
  },
  {
    value: 'BEFORE_MOVE_IN_CALENDAR_DAYS_28',
    text: 'cms:cms.properties.edit.detail.cancellation_period.28_calendar_days',
  },
  {
    value: 'BEFORE_MOVE_IN_CALENDAR_DAYS_30',
    text: 'cms:cms.properties.edit.detail.cancellation_period.30_calendar_days',
  },
  {
    value: 'BEFORE_MOVE_IN_CALENDAR_DAYS_60',
    text: 'cms:cms.properties.edit.detail.cancellation_period.60_calendar_days',
  },
  {
    value: 'BEFORE_MOVE_IN_CALENDAR_DAYS_90',
    text: 'cms:cms.properties.edit.detail.cancellation_period.90_calendar_days',
  },
  {
    value: 'NON_REFUNDABLE',
    text: 'cms:cms.properties.edit.detail.cancellation_period.non_refundable',
  },
];

export const billingCycleOptions = [
  { value: 'DAYLY', text: 'cms:cms.properties.edit.detail.billing_cycle.option_day' },
  { value: 'WEEKLY', text: 'cms:cms.properties.edit.detail.billing_cycle.option_week' },
  { value: 'MONTHLY', text: 'cms:cms.properties.edit.detail.billing_cycle.option_month' },
];

export const typeOptions = [
  {
    value: 'student-accommodation',
    text: 'cms:cms.properties.edit.detail.type.student-accommodation',
  },
  { value: 'multi-family', text: 'cms:cms.properties.edit.detail.type.multi-family' },
  { value: 'long-tail', text: 'cms:cms.properties.edit.detail.type.long-tail' },
  { value: 'hotel', text: 'cms:cms.properties.edit.detail.type.hotel' },
  { value: 'serviced-apartment', text: 'cms:cms.properties.edit.detail.type.serviced-apartment' },
  { value: 'real-estate-agent', text: 'cms:cms.properties.edit.detail.type.real-estate-agent' },
];

export const rankTypeOptions = [
  { value: 'NORMAL', text: 'cms:cms.properties.edit.tab_label.others.ranking_type_normal' },
  { value: 'STAR', text: 'cms:cms.properties.edit.tab_label.others.ranking_type_star' },
  {
    value: 'BLACKSHEEP',
    text: 'cms:cms.properties.edit.tab_label.others.ranking_type_black_sheep',
  },
];

export const cancellationPeriodTypeValue = {
  BEFORE_MOVE_IN: 'BEFORE_MOVE_IN',
  UNTIL_MOVE_IN_DAY: 'UNTIL_MOVE_IN_DAY',
  NON_REFUNDABLE: 'NON_REFUNDABLE',
  AFTER_BOOKING_CONFIRMED: 'AFTER_BOOKING_CONFIRMED',
};

export const cancellationPeriodTypeOptions = [
  {
    value: cancellationPeriodTypeValue.BEFORE_MOVE_IN,
    text: 'cms:cms.properties.edit.detail.cancellation_period.before_move_in',
  },
  {
    value: cancellationPeriodTypeValue.UNTIL_MOVE_IN_DAY,
    text: 'cms:cms.properties.edit.detail.cancellation_period.until_move_in_day',
  },
  {
    value: cancellationPeriodTypeValue.NON_REFUNDABLE,
    text: 'cms:cms.properties.edit.detail.cancellation_period.non_refundable',
  },
  {
    value: 'AFTER_BOOKING_CONFIRMED',
    text: 'cms:cms.properties.edit.detail.cancellation_period.after_booking_confirmed',
  },
];
